exports = module.exports = require("../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.title[data-v-7767d84c] {\n  font-size: 0.4266rem;\n  margin-top: 0.4rem;\n}\n.course_footer[data-v-7767d84c] {\n  -webkit-box-sizing: border-box;\n  position: relative;\n  margin-top: 0.42rem;\n  text-align: center;\n  font-size: 0.4533rem;\n  font-weight: bold;\n  padding: 0 0.4rem;\n  width: 100%;\n  height: 2.9333rem;\n  margin-bottom: 0.4rem;\n}\n.course_footer img[data-v-7767d84c] {\n  width: 100%;\n  height: 2.9333rem;\n  margin-bottom: 0.4rem;\n}\n", ""]);

// exports
